/**
 * 开发仓等：库位编码 A1-0 … A1-19 按「排」分组（A1 / A2 / …）。
 * 规则：取最后一个「-数字」前的前缀为排号（大小写不敏感，展示用大写）。
 */

export function parseLocationRowParts(locationCode) {
  const raw = String(locationCode || '').trim()
  if (!raw) return null
  const m = raw.match(/^(.*)-(\d+)$/)
  if (!m) {
    return { rowKey: raw.toUpperCase(), suffix: null, displayCode: raw }
  }
  const prefix = (m[1] || '').trim()
  if (!prefix) return null
  const suffix = parseInt(m[2], 10)
  return {
    rowKey: prefix.toUpperCase(),
    suffix: Number.isFinite(suffix) ? suffix : null,
    displayCode: raw
  }
}

/**
 * 在库位列表中收集与 seed 同排的 location_id（按后缀数字升序）。
 * @param {Array<{location_id:number, location_code?:string}>} locations
 * @param {{location_id:number, location_code?:string}} seedLoc
 * @returns {{ rowKey: string|null, locationIds: number[], members: Array }}
 */
export function collectSameRowLocations(locations, seedLoc) {
  const seedParts = parseLocationRowParts(seedLoc?.location_code)
  if (!seedParts?.rowKey) {
    const id = Number(seedLoc?.location_id)
    return {
      rowKey: null,
      locationIds: id ? [id] : [],
      members: id
        ? [{ location_id: id, location_code: seedLoc.location_code, suffix: null }]
        : []
    }
  }
  const members = []
  for (const loc of locations || []) {
    const p = parseLocationRowParts(loc?.location_code)
    if (!p || p.rowKey !== seedParts.rowKey) continue
    const lid = Number(loc.location_id)
    if (!lid) continue
    members.push({
      location_id: lid,
      location_code: loc.location_code,
      location_name: loc.location_name,
      suffix: p.suffix
    })
  }
  members.sort((a, b) => {
    const sa = a.suffix == null ? Number.POSITIVE_INFINITY : a.suffix
    const sb = b.suffix == null ? Number.POSITIVE_INFINITY : b.suffix
    if (sa !== sb) return sa - sb
    return String(a.location_code || '').localeCompare(String(b.location_code || ''), 'en', {
      numeric: true
    })
  })
  return {
    rowKey: seedParts.rowKey,
    locationIds: members.map(m => m.location_id),
    members
  }
}
